import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#BE2F37",
      200: "#BE2F37",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#BE2F37",
      500: "#BE2F37",
      600: "#BE2F37"
    },
    secondary: {
      100: "#D7BA8A",
      200: "#D38232",
      300: "#BE2F37"
    },
    background: {
      100: "#F8E0E2",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#F8E0E2"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#C6653B",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    outletLocationRestText: "#BE2F37",
    orderOnlineHomeButton: "#BE2F37",
    errorModalHeaderBg: "#fff",
    circularAddBtn: "#BE2F37",
    locationListBtn: "#BE2F37",
    startBgColor: "#EDEDEC",
    secondary200Mobile: "#BE2F37",
    confirmationModalOptionBg: "#F8E0E2",
    asapOptionBg: "#F8E0E2",
    asapTextColor: "#303030",
    emptyCartHeaderBgColor: "#F2EFEA",
    menuItemCardBg: "#FFFFFF",
    menuButtonBackgroundColor: "#BE2F37",
    orderSettingsTextColor: "#BE2F37",
    categoriesText: "#BE2F37",
    modalCategoriesText: "#BE2F37",
    inActiveCategoriesText: "#303030",
    inActiveModalCategoriesText: "#606060",
    menuItemAddButtonColor: "#BE2F37",
    menuDetailsMobileHeaderText: "#BE2F37",
    menuItemNameColor: "#303030",
    cartHeaderOrderType: "#282C25",
    cartHeaderLocationName: "#BE2F37",
    configOptionsAccordionBackground: "#BE2F37",
    hStackArrowsColor: "#BE2F37",
    menuDetailsModifiersBorderColor: "#BE2F37",
    menuDetailsBackToMenu: "#000",
    infoLinkColor: "#BE2F37",
    legalDisclaimerText: "#70695c",
    headerBackground: "#000",
    headerBackgroundTop: "#000",
    sliderItemColor: "#BE2F37",
    btnHoverColor: "#EC3F47",
    timeDropDownBg: "#FFFFFF",
    reservationsCardBg: "#fff",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#FFFFFF",
    itemAddToCartPopupBackground: "#BE2F37",
    confirmPickupDetailsText: "#BE2F37",
    defaultMenuTextColor: "#020001",
    orderConfirmationTextColor: "#BE2F37",
    previousOrderItemStatus: "#BE2F37",
    defaultMenuBannerBg: "#F8E0E2",
    selectedOptionBorderColor: "#BE2F37",
    scrollToTopColor: "#BE2F37",
    menuItemCardBorder: "transparent",
    menuItemPriceColor: "#303030",
    menuItemCalorieColor: "#303030",
    refreshIconColor: "#BE2F37",
    accordionDescription: "white",
    searchResultsName: "#303030",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "transparent",
    categoryNavBgColor: "#fff",
    plusIconColor: "#BE2F37",
    specialInstArrowColor: "black",
    itemIsFor: "#606060",
    downArrowColor: "#020001",
    mobileBg: "#FFFFFF",
    itemIsForName: "#282C25",
    cartPhoneNumber: "#BE2F37",
    cartItemActionBtn: "#BE2F37",
    cartItemPrice: "#BE2F37",
    cartNoOfItemsText: "#fff",
    selectedMenuCategoryBorder: "#BE2F37",
    orderSettingsDesktop: "#303030",
    orderSettingsMobile: "#303030",
    cartItemTitle: "#303030",
    specialInstructions: "#282C25",
    cartItemOption: "#303030",
    menuDetailsSliderItemBackground: "#F8E0E2",
    menuDetailItemNameColor: "#303030",
    menuDetailsItemPriceColor: "#303030",
    ninjaIconColor: "#BE2F37",
    menuDetailsItemDescriptionColor: "#282C25",
    menuDetailsItemCaloriesCaolor: "#BE2F37",
    menuDetailsSliderHoverColor: "#BE2F37",
    loginModalTextColor: "#BE2F37",
    hStackArrowsBg: "#FDFDFDD9",
    requiredTextColor: "#BE2F37",
    menuDetailAccordionTextColor: "#303030",
    menuDetailModifyOrRemoveColor: "#464838",
    locationConfirmationHeadings: "#BE2F37",
    locationListingItemHeading: "#BE2F37",
    locationListingItemHeadingMobile: "#BE2F37",
    locationListingItemText: "#303030",
    reorderInfoTextColor: "#606060",
    menuDetailAccordionDownArrowColor: "#fff",
    recommendationaInfoTextColor: "#282C25",
    reOrderAddBtnBorder: "#BE2F37",
    recommendationHeadingColor: "#020001",
    sliderWithButtonsBackground: "#FFFFFFE5",
    orderSettingsDateTimeChoiceColor: "#2D2926",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    menuDetailsAccordionDetailsBackground: "#F4F4F3",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#F4F4F3",
    locationsNear: "#2A2C25",
    categoryBoxDivider: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    remoteCheckinWaitTimeHeaderText: "#BE2F37",
    remoteCheckinWaitTimeText: "#BE2F37",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#BE2F37",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    quantityArrowColor: "#BE2F37",
    textCTAColor: "#BE2F37",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    selectedCarouselItemWithoutImage: "#F8E0E2",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#BE2F37",
    selectedListItem: "#F8E0E2",
    // NEED
    menuListTooltipBg: "#BE2F37",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#54301A",
    menuDetailTooltipColor: "#FFFFFF",
    themeErrorTextColor: "#AF272F",
    themeErrorColor: "#C03838",
    youMightLikeBannerColor: "#BE2F37",
    newIndicatorBannerColor: "#C6653B",
    skuUnavaliableTextColor: "#A2402A",
    menuDetailTemparatureSliderLabelColor: "#303030",
    globalBannerBg: "#000",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    bannerDropShadow: "#5F2C2D",
    deliveryModalNameColor: "#A2402A",
    addressTextColor: "#303030",
    notSelectedOptionBorderColor: "#D7D7D7",
    // OLD COLORS
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    listItemDivider: "#D6D6D6",
    cartNumberText: "#BE2F37",
    themeSectionTextDark: "#8A8A8A",
    backLinkColor: "#BE2F37",
    themeTextColor: "#606060",
    legalDesclaimerText: "#303030",
    themeGrey: "#606060",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#2A2C25",
    categoryHeaderSeparator: "#EAEAEA",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#606060",
    themeDarkGrey: "#2E2A26",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#ffffff",
    allLocationsSelectBgDesktop: "#ffffff",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#ffffff",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#ffffff",
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#4D2C42",
    locaionAndTimeHeaderBg: "#F8E0E2",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#BE2F37",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#BE2F37",
    orderStatusSectionBg: "#F4F4F4",
    refreshButtonColor: "#BE2F37",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    refreshButtonBg: "#FFFFFF",
    orderStatusSectionBorderColor: "#F4F4F4",
    // order tracking page end
    // NOT USED
    nutritionalHTMLColor: "#020001",
    reorderHeadingsText: "#020001",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#BE2F37",
    categoriesDescriptionColor: "#606060",
    itemUnavailableCardBg: "#F8E0E2",
    itemCardBg: "#F8E0E2",
    itemCardBgLight: "#F8E0E2",
    orderConfirmationCustomerEmail: "#494949",
    // ORDER CONFIRMATION START
    orderConfirmationBackground: "#F6F6F6",
    confirmationPrimary: "#BE2F37",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#BE2F37",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F8E0E2",
    menuInfoBackgroundMobile: "#ddd",
    menuInfoBackgroundDesktop: "#ddd",
    selectedSKUItem: "#F8E0E2",
    nonSelectedSkuItem: "white",
    configOptionBg: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#BE2F37",
    selectedDescriptionText: "#020001",
    remoteCheckinWaitTimeBg: "#F8E0E2",
    remoteCheckinWaitTimeBorderTwo: "rgba(115,153, 74, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(115,153, 74, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "#BE2F37",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#282C25",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#303030",
    registerTextColor: "#303030",
    recommendationsHeadingColor: "#303030",
    capacityInfoText: "#606060",
    selectedStateColor: "#2A2C25",
    pickupDateTimeText: "#303030",
    quantityColor: "#000000",
    timeDropdownColor: "#000",
    searchKeywordHighlightColor: "#BE2F37",
    waitlistBannerBg: "#BE2F37",
    waitlistTableHeaderBg: "#F8F8F8",
    selectedWaitlistRow: "#F8E0E2",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistBottomBackground: "#F8E0E2",
    waitlistDisclaimer: "#282C25",
    //Menu search
    searchModalCategoryListBg: "#fff",
    searchIconContainerBgColor: "#DF4505",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    // new
    profileHeaderBackground: "#BE2F37",
    locationTopTabColor: "#BE2F37",
    grey300: "#303030",
    reoderInfoTextColor: "#404040",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    onboardingButtonTextColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    myReservationsBoxBg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#BE2F37",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "rgba(68, 59, 53, 0.5)",
    linearGradientHeaderLight: "rgba(105, 86, 76, 0.2)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F5F7E8",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#B31900",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#BE2F37",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#BE2F37",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#BE2F37",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#B31900",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#BE2F37",
    restaurantAboutSectionBodyTextColor: "#606060",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#BE2F37",
    waitlistRestaurantInfoBoxText: "#54301A",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#BE2F37",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#303030",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#F6F6F6",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#223E6A",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    currentWeekDayIndicator: "#49909B",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: "#F6F6F6",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "#931219",
    mobileGiftCardGradientSecond: "#0F0001",
    mobileMasterCardGradientFirst: "#1D338F",
    mobileMasterCardGradientSecond: "#1D338F",
    mobileMasterCardGradientThird: "#286F97",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#e3e3e3",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BF7D3F",
    waitlistHomeScreenBannerGradientTwo: "#964631",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenMobileBackgroundColor: "#F6F6F6",
    myAccountScreenWebBackgroundColor: "#fff",
    myAccountScreenUserInfoTextColor: "#303030",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#BF7D3F",
    curbsideHomeScreenBannerGradientTwo: "#964631",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#FFFFFF",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#BE2F37",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#BE2F37",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#ffffff",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    showCreditCard_bottomSheet_BackgroundColor: "#EDEDEC",
    addEditCreditCard_scrollView_backgroundColor: "#F6F6F6",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2402A",
    menuCustomisationIsSelectedMobileColor: "#F3F4EA",
    menuCustomisationIsSelectedBorderMobileColor: "#A8AD00",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#BE2F37",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#BE2F37",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION START
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#606060",
    noResultFoundMenuSearchBg: "#DDD",
    searchModalBackgroundColor: "#F6F6F6",
    menuSearchModalDivider: "#ABABAB",
    searchCardCategorySlugColor: "grey",
    inputFieldBackgroundColor: "#fff",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#B31900",
    backgroundE5E5: "#E5E5E5",
    searchItemCardTextColor: "#505050",
    menuSearchBarContainerBg: "#FFFFFF",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#F6F7F0",
    paymentOptionsBorderColor: "#DCDCDC",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#BE2F37",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#000000",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.4)",
    onboardingButtonBackgroundColor: "#BE2F37",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F8E0E2",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    checkoutGratuitySliderMinTrackColor: "#BE2F37",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#BE2F37",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#BE2F37",
    homescreenWaitlistButtonTextColor: "#BE2F37",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    recentOrdersListItemPrice: "#BE2F37",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#BE2F37",
    profileHeaderLinearGradientEndColor: "#BE2F37",
    profileAddCardButtonText: "#000000",
    searchBarBorderColor: "#D6D6D6",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    mobilePayConfirmationScreenBlockBG: "#F8E0E2",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#BE2F37",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#F8E0E2",
    reservationUnSelectedCTABGColor: "#FFF",
    reservationPopupBgColor: "#fff",
    reservationSelectedSeatingOption: "#F8E0E2",
    reservationCalendarCtaBorderRadius: 0,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBYearBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationInputErrorColor: "#DF4505",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#282C25",
    orderTotalTextColor: "#494949",
    orderTotalPriceColor: "#B31900",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#BE2F37",

    /* Restaurant Details */
    restaurantDetailsBGColor: "#f6f6f6",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#BE2F37",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#F6F6F6",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#BE2F37",
    restaurantDetailsNotSelectedWeekDayTextColor: "#404040",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restDetailsRestInfoTitleColor: "#303030",
    mobilePayHeaderBtnBorder: "#BE2F37",
    restaurantInfoAddressTextColor: "#B31900",
    restaurantInfoAddToFavouritiesTextColor: "#BE2F37",
    restaurantTimingWeekDayTextColor: "#BE2F37",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#C16436",
    imageStackBorderColor: "#FFFFFF",
    calenderTodayBackgroundColor: "#BE2F37",
    calenderSelectedDayColor: "#BE2F37",
    calenderSelectedDayTextColor: "#FFF",
    calenderSelectedDayStyleBGColor: "#BE2F37",
    reserveTableHeaderRightButtonText: "#BE2F37",
    reserveConfirmationDescriptionHeaderBg: "#485062",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#E0DED8",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#BE2F37",
    homescreenLocationTextColor: "#303030",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#fff",
    searchThisAreaBg: "#BE2F37",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#BE2F37",
    allLocationsLsBg: "#FFFFFF",
    callRestLsText: "#BE2F37",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#000",
    lsAllLocationsSelectBorder: "#D6D6D6",
    locationListingItemHeadingInPage: "#BE2F37",
    allLocationsLSPageBg: "#f6f6f6",
    locationSearchAddressColor: "#303030",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#BE2F37",
    hoursInfoAccordionTitle: "#BE2F37",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#B31900",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#BE2F37",
    viewMenuHover: "#BE2F37",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#BE2F37",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#BE2F37",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#B31900",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#B31900",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#DDDDDD",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#F8E0E2",
    topTabCountInactiveBg: "#DAD4D5",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F8E0E2",
    criticalModeBg: "#fafafa",
    reorderAddItemBg: "#BE2F37",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#B31900",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#B31900",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#BE2F37",
    selectedOrderTypeTextColor: "#BE2F37",
    mobileCalendarTextColor: "#BE2F37",
    gcBalanceRefreshBorderTextColor: "#BE2F37",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    reservationLocationModalDeskHeaderBg: "#000",
    reservationLocationModalMobHeaderBg: "rgb(48,48,48)",
    reservationLocationListBg: "#F6F6F6",
    reservationsSpecialRequestSwitch: "#BE2F37",
    reservationBg: "#F6F6F6",
    reservationStaticTextBg: "#fff",
    reservationTabsBg: "#BE2F37",
    reservationDropDownIconColor: "#000",
    reservationPickerHoverColor: "#F8E0E2",
    reservationNoOfGuestsSelectedBg: "#BE2F37",
    reservationNoOfGuestsNotSelectedBg: "white",
    reservationsTimePickerBg: "white",
    reservationActionButtonsBg: "white",
    reservationInactiveSelectTime: "#EDEDEC",
    confirmationModalBorderRadius: 0,
    cancelConfirmationModalBorderRadius: 0,
    reservationUserInitials: "#BE2F37",
    preferredLocationCloseButtonBg: "transparent",
    preferredLocationCloseButtonHover: "#000",
    preferredLocationModalContentColor: "#f6f6f6",
    preferredLocationCloseButtonIconColor: "#fff",
    reservationHoveredText: "#303030",
    reservationNotHoveredText: "#303030",
    reservationsCardsBodyBg: "#F6F6F6",
    reservationSpecialRequests: "#FFFFFF",

    /** Colors: Private Dining Start */
    minimalHeaderSignInBtn: "#BE2F37",
    makeRequestPageBg: "#ddd",
    requestFormTabActiveItem: "#BE2F37",
    requestFormTabDisableItem: "#BE2F37",
    splRequestToggleTrackColor: "#BE2F37",
    pdPurposeDropDownOptionHover: "#F8E0E2",
    pdTimeDropDownOptionHover: "#BE2F37",
    pdPartySizeRangeOptionHover: "#BE2F37",
    pdmenuPrefOptionHover: "#F8E0E2",
    pdFooterPrivacyNotice: "#BE2F37",
    pdContactDetailsEdit: "#BE2F37",
    pdReviewDetailsEventInfoDivider: "#D8D8D8",
    pdConfirmationMobileBg: "#F6F6F6",
    pdRequestFormInputBg: "#FFFFFF",
    pdRequestFormInputBorder: "#DDD",
    pdFooterBg: "#FFFFFF",
    pdActionSheetBody: "#FFFFFF",
    pdMobilePageBg: "#F6F6F6",
    eventPurposeSelectorColor: "#70695C",
    eventPurposeSelectorHoverColor: "#70695C",
    pdContactsPhoneTypeDivider: "#F3F3F3",
    pdCallRestDividerORText: "#70695C",
    pdCallRestContinueSubmiting: "#BE2F37",
    pdLandingMenuTabBg: "#F6F6F6",
    pdLandingLocationInfoMobileBg: "#F6F6F6",

    /** Colors: Private Dining End */
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000",
    desktopTopTabsBG: "#EDEDEC",
    menuSearchModalCloseIconColor: "#fff",
    menuSearchInputBorder: "#DDD",
    menuSearchResultContainerBG: "transparent",
    pdRequestFormBG: "#F6F6F6",
    eClubHoverActiveColor: "#F0ECE6",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#F0ECE6",
    eClub_confirmation_background_color: "#F0ECE6",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F0ECE6",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    pdInputDataTextColor: "#303030",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    EClubInputErrorColor: "#DF4505",
    reservationSelectTimeTextColor: "#606060",
    pdLocationListBg: "#F6F6F6",
    pdLocationListBgMobile: "#F6F6F6",
    pdLandingDropdownActive: "#be2f37",
    pdLandingDropdownInActive: "#FFFFFF",
    scrollToTopBgColorMobile: "#F6F6F6",
    menuListingContainerBG: "#f6f6f6",
    locationSearchTabBgColor: "#000",
    locationListBgColor: "#f6f6f6",
    locationsSearchPageLocationListItemBgColorMobile: "#f6f6f6",
    smartRecommendationCardbg: "white",
    locationSearchScrollToTopBg: "#f6f6f6",
    menuItemcardVerticalImageBorderRadius: "none",
    scrollToTopBgColor: "white",
    joinEclubContainerBgColor: "#F6F6F6",
    editProfile_modalHeaderBackgroundColor: "#F6F6F6",
    editProfile_modalBodyBackgroundColor: "#FFFFFF",
    confirmationModalCTABackgroundColor: "#BE2F37",
    giftCardLargeBody_BackgroundColor: "#FFFFFF",
    giftCardLargeBody_webModalBackgroundColor: "#FAFAFA",
    giftCardLargeHeader_BackgroundColor: "#EDEDEC",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#F6F6F6",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#606060",
    orderHistoryModalHeaderTextColor: "#303030",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    EclubFormInputPlaceholderTextColor: "#808080",
    EclubDOBBottomBorderColor: "#B6B6B6",
    joinEclubDOBTextColor: "#BE2F37",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    reservationShareIconText: "#606060",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    globalMessageBannerPadding: 2,
    errorDialogModalBorderRadius: 0,
    itemIsForBgColor: "#ddd",
    locationListItemOrderText: "#BE2F37",
    locationListItemOrderBg: "white",
    locationListItemOrderHoverBg: "#EC3F47",
    locationListItemOrderHoverText: "white",
    locationListItemOrderPadding: "11px",
    orderDetailsCartItemPrice: "#000000",
    myAccountBgImageOverlay: "#F7F7F7",
    myAccountCardBackgroundActive: "#F8E0E2",
    myAccountChangeFieldModalBg: "#F5F0E6",
    myAccountEditProfileScrollViewBg: "#FFFFFF",
    editProfileFullBottomButtonBackgroundColor: "#F6F6F6",
    orderHistoryFullBottomButtonBackgroundColor: "#FFFFFF",
    myAccountCalendarCtaBorderRadius: 0,
    myAccountDOBTextColor: "#BE2F37",
    orderHistoryDetailsHeaderModalBackgroundColor: "#F6F6F6",
    myAccountSkipConfirmationCTA: "#BE2F37"
  },
  components: {
    Pressable: {
      variants: {
        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 0,
          px: 6,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center",
          _text: {
            color: "red.100"
          }
        },
        reservationConfBackHomeBtn: {
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300",
          display: "none"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 0,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 0,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#F6F6F6",
          borderColor: "suggestionsBorderColor",
          borderRadius: 0
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            backgroundColor: "white",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            backgroundColor: "white",
            borderWidth: 1,
            // width: "100%",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref4) {
          var radiusValue = _ref4.radiusValue,
              topRadiusValue = _ref4.topRadiusValue,
              bottomRadiusValue = _ref4.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewCartBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        },

        /** Pressable: Private Dining Start */
        privateDiningLocationSelectionBtn: {
          borderRadius: 0,
          px: 6,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        privateDiningModalCancelCTA: {
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#BE2F37",
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          w: "100%"
        },
        privateDiningModalConfirmCTA: {
          bg: "#BE2F37",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 0,
          w: "100%",
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#BE2F37"
        },
        privateDiningCallRest: {
          borderWidth: 1,
          borderColor: "#BE2F37",
          borderRadius: 0
        },

        /** Pressable: Private Dining End */
        pd_landing_menuTabs_Item: function pd_landing_menuTabs_Item(_ref5) {
          var isActive = _ref5.isActive;
          return {
            bgColor: isActive ? "#BE2F37" : "transparent",
            px: 6,
            py: 1.5,
            borderRadius: 0
          };
        },
        pd_landing_noLocation_selectCTA: {
          bgColor: "primary.100",
          mt: {
            base: 8,
            md: 12
          },
          py: 3.5,
          px: 24,
          width: {
            base: "100%",
            sm: "auto"
          }
        },
        pd_landing_eventGuideCTA: {
          width: {
            base: "100%",
            lg: "273px"
          },
          borderColor: "#BE2F37",
          borderWidth: 1,
          borderRadius: 0
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: {
          my: 1,
          borderRadius: 0,
          width: "100%",
          backgroundColor: "#BE2F37",
          _web: {
            my: 0
          },
          flex: 1,
          ml: 2,
          border: 1.5,
          borderColor: "#BE2F37"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto",
          bg: "#EDEDEC"
        },
        myAccount_paymentOptions_checkBalanceCTA: {
          marginY: 1,
          border: 1.5,
          borderColor: "#BE2F37",
          borderRadius: 0,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref6) {
          var isActive = _ref6.isActive;
          return {
            borderRadius: 0,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "#FFFFFF",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4
        },
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4,
          _web: {
            bg: "#BE2F37"
          }
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {},
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "#BE2F37",
          px: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          borderRadius: 0
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "#BE2F37",
          borderRadius: 0
        },
        eClubStickySignUpDesktopPressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          bg: "secondary.300",
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 10,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          bg: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 10,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        }
      }
    },
    Button: {
      baseStyle: {
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        },
        borderRadius: "0px"
      },
      variants: {
        solid: {
          bg: "primary.100",
          _pressed: {
            bg: "#8C1319"
          },
          _hover: {
            bg: "#EC3F47"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "transparent"
          }
        },
        camAccessBtn: {
          bg: "#5A783A",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "primary.100",
          _pressed: {
            bg: "#8C1319"
          },
          _hover: {
            bg: "#EC3F47"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "white",
            fontWeight: "600",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#EC3F47"
          },
          _pressed: {
            bg: "#8C1319"
          }
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref7) {
          var borderRadiusValue = _ref7.borderRadiusValue;
          return {
            marginBottom: 5,
            borderRadius: 0,
            _text: {
              color: "#FFFFFF"
            },
            bg: "#BE2F37"
          };
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref8) {
          var borderRadiusValue = _ref8.borderRadiusValue;
          return {
            marginBottom: 5,
            marginTop: 0,
            borderRadius: 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#BE2F37"
          };
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            padding: 1,
            _text: {
              color: "#BE2F37",
              fontFamily: "body",
              fontWeight: "600",
              _web: {
                fontSize: "12px"
              },
              textTransform: "uppercase",
              margin: 2,
              pt: 1
            },
            bg: "white",
            _hover: {
              bg: "locationListItemOrderHoverBg",
              _text: {
                color: "locationListItemOrderHoverText"
              }
            },
            _pressed: {
              bg: "#8C1319",
              _text: {
                color: "locationListItemOrderHoverText"
              }
            },
            borderWidth: 1,
            borderColor: "#BE2F37",
            width: "126px"
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            padding: 0,
            _text: {
              color: "#BE2F37",
              fontFamily: "body",
              fontWeight: "600",
              _web: {
                fontSize: "15px"
              },
              textTransform: "uppercase",
              margin: 2,
              pt: 1
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "white",
            _hover: {
              bg: "#EC3F47",
              _text: {
                color: "locationListItemOrderHoverText"
              }
            },
            _pressed: {
              bg: "#8C1319",
              _text: {
                color: "locationListItemOrderHoverText"
              }
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "#FFF",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 500,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref10) {
          var isActive = _ref10.isActive,
              isMobile = _ref10.isMobile,
              isLongText = _ref10.isLongText;
          return {
            px: {
              base: 2,
              md: 9
            },
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            ml: isLongText && isMobile && 5,
            width: !isMobile && (isLongText ? "100%" : 32),
            height: {
              base: 8,
              md: 9
            },
            _web: {
              borderRadius: "0px",
              width: !isMobile && (isLongText ? "100%" : "117px")
            },
            borderRadius: 0,
            rounded: 0,
            _text: {
              color: isActive ? "white" : "#303030",
              fontWeight: "600",
              fontSize: isMobile ? "xs" : "16",
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: {
                  base: "14px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase",
              fontFamily: "heading",
              pt: 1
            }
          };
        },
        pillButton: function pillButton(_ref11) {
          var isActive = _ref11.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "orderSettingsDateTimeChoiceColor"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref12) {
          var isUnavailable = _ref12.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "primary.100",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "#8C1319"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "#EC3F47"
            },
            _text: {
              fontWeight: "700"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 0
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#BE2F37",
          borderWidth: 1
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "0px"
            }
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#00A9A1"
        },
        // LS tokens
        locationListItemButton: {
          _text: {
            // fontFamily: "TradeGothicLTStd-Medium",
            fontWeight: "600",
            fontSize: {
              base: "13px",
              md: "12px"
            },
            pt: 1
          }
        },
        locationListItemOrder: {
          borderWidth: 1,
          borderColor: "secondary.300"
        },
        viewMenuBtn: {
          borderRadius: 0,
          padding: 0,
          borderWidth: 1,
          borderColor: "secondary.300",
          _text: {
            color: "secondary.300",
            marginY: "11px",
            marginX: 6,
            fontSize: "18px",
            fontWeight: "600",
            letterSpacing: -0.3,
            lineHeight: 4
          }
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "primary.100"
          };
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref13) {
          var isLocationSearch = _ref13.isLocationSearch,
              fromAllLocations = _ref13.fromAllLocations;
          return {
            borderRadius: 0,
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 6,
              fontWeight: "600",
              fontSize: "15px",
              pt: 1
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "#EC3F47",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "#8C1319"
            },
            ml: 2
          };
        },
        locationListItemButtonBorderRadius: 0,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6,
              borderRadius: 0
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref14) {
          var radiusValue = _ref14.radiusValue,
              topRadiusValue = _ref14.topRadiusValue,
              bottomRadiusValue = _ref14.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#FFF",
              fontWeight: 400,
              pt: 1
            },
            borderColor: "#FFF",
            borderRadius: 0,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "#000"
            },
            bg: "transparent",
            borderWidth: 1
          };
        },

        /** Button: Private Dining Start */
        pd_Header_LoginButton: function pd_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#FFF",
              fontWeight: 400,
              textTransform: "uppercase"
            },
            px: "17px",
            py: "10px"
          };
        },
        pd_request_eventDetails_confirmCTA: function pd_request_eventDetails_confirmCTA() {
          return {
            borderRadius: 0,
            backgroundColor: "#BE2F37",
            padding: 0,
            marginTop: 4,
            marginX: 5,
            marginBottom: 3,
            h: 12,
            _text: {
              color: "white",
              letterSpacing: -0.5,
              fontWeight: "400",
              fontSize: 18,
              marginTop: 3,
              marginBottom: 3,
              lineHeight: 6,
              textAlign: "center",
              textTransform: "uppercase"
            },
            _pressed: {
              opacity: 0.8
            }
          };
        },
        pd_requestForm_Footer_cancalCTA: function pd_requestForm_Footer_cancalCTA() {
          return {
            bg: "none",
            border: 2,
            borderRadius: 0,
            borderColor: "#BE2F37",
            _text: {
              fontSize: 16,
              color: "#BE2F37",
              pt: 1
            },
            _hover: {
              bg: "none"
            }
          };
        },
        pd_requestForm_Footer_ContinueCTA: function pd_requestForm_Footer_ContinueCTA() {
          return {
            _text: {
              fontSize: 16,
              color: "white",
              pt: 1
            },
            bg: "#BE2F37",
            borderRadius: 0
          };
        },
        pd_confirmation_backToHomeCTA: {
          bg: "none",
          border: 2,
          borderRadius: 0,
          borderColor: "#BE2F37",
          px: 12,
          mt: 8,
          _text: {
            fontSize: 16,
            color: "#BE2F37",
            fontWeight: "600",
            pt: 1
          },
          _hover: {
            bg: "none"
          }
        },
        confirmAndAddToCartButton: {
          _ios: {
            borderRadius: 0
          },
          _android: {
            borderRadius: 0
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          }
        },

        /** Button: Private Dining End */
        ErrorDialogOKButton: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#ba4841"
          }
        },
        pd_landing_stickyFooter_pdReqCTA: {
          py: 2.5,
          width: {
            base: "100%",
            md: "469px"
          },
          height: 12,
          bgColor: "#BE2F37"
        },
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1.5,
          borderColor: "#BE2F37",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "#BE2F37",
            letterSpacing: "-0.3"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            }
          }
        },
        editProfileFullBottomButton: {
          _text: {
            fontSize: {
              base: 18,
              md: 16
            },
            textTransform: "uppercase",
            lineHeight: {
              base: 5,
              md: 6
            },
            textAlign: "center",
            letterSpacing: "-0.3",
            color: "#FFFFFF",
            fontWeight: 500,
            marginBottom: {
              base: 3,
              md: 6
            },
            marginTop: {
              base: 2,
              md: 5
            }
          },
          bg: "#BE2F37"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "#BE2F37"
        },
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "#BE2F37",
          mx: "auto"
        },
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 2,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          borderWidth: 1.5,
          bg: "#FFFFFF",
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 500,
            letterSpacing: "-0.3"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _text: {
            py: 1,
            fontWeight: 500,
            letterSpacing: "-0.3"
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {},
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "#BE2F37",
            letterSpacing: "-0.3"
          },
          bg: "transparent",
          borderColor: "#BE2F37",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            fontWeight: 500,
            textAlign: "center",
            color: "#FFFFFF",
            letterSpacing: "-0.3",
            textTransform: "uppercase"
          },
          bg: "#BE2F37"
        },
        orderHistoryReorderFullBottomButton: {
          _text: {
            fontWeight: 500,
            letterSpacing: "-0.3",
            textTransform: "uppercase",
            lineHeight: 6,
            textAlign: "center",
            fontSize: 18,
            color: "white",
            marginBottom: {
              base: 3,
              md: 4
            },
            marginTop: {
              base: 3,
              md: 4
            }
          }
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#BE2F37"
          }
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref15) {
          var isMandatory = _ref15.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "0"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8 // display: "none",

        }
      }
    },
    ModalBody: {
      variants: {
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          borderRadius: 0,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 0,
          bg: {
            base: "#F8F7F6",
            md: "#FFFFFF"
          },
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref16) {
          var radiusValue = _ref16.radiusValue,
              topRadiusValue = _ref16.topRadiusValue,
              bottomRadiusValue = _ref16.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        pd_cancelModal: {
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "335px",
          py: 8,
          px: 6,
          borderRadius: 0
        },
        pd_callRestModal: {
          maxW: "335px",
          py: 8,
          px: {
            base: 5,
            md: 7
          },
          borderRadius: 0
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 0
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 0
        },
        editFieldsConfirmationModal: {
          borderRadius: 0,
          p: 12,
          bgColor: "#FFFFFF"
        },
        editFieldsSuccessModal: {
          borderRadius: 0,
          p: 12,
          maxWidth: {
            md: "588"
          },
          bgColor: "#FFFFFF"
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref17) {
          var isMandatory = _ref17.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref18) {
          var isMandatory = _ref18.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref19) {
          var isDefaultExpanded = _ref19.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "0"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 0
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        },
        pd_landing_stickyFooter_container: {
          direction: {
            base: "column-reverse",
            lg: "row"
          },
          bgColor: "#F6F6F6",
          alignItems: "center",
          justifyContent: "space-between",
          py: {
            base: 3,
            md: 7
          },
          px: {
            base: 5,
            md: 32
          },
          shadow: {
            base: 14,
            md: 0
          }
        }
      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      defaultProps: {
        paddingTop: 2,
        color: "#303030"
      },
      variants: {
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },

        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: "700",
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          textAlign: "center",
          color: "#70695C"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#FFF"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#FFF"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#FFF"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 600,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap",
          color: "#606060"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500,
          pt: 0
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 500
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 400
        },
        reservationLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 500
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200,
          color: "#606060"
        },
        reservationLocationModalHeaderText: {
          color: "#fff",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref20) {
          var isActive = _ref20.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#BE2F37" : "#FFF",
            fontSize: {
              base: 18,
              md: 18
            },
            mt: 2,
            fontWeight: 500,
            lineHeight: "normal",
            letterSpacing: "-0.3px",
            pt: 1
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 5
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 12,
          color: "#707070",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 12,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 5,
          color: "grey300"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "18px",
          fontWeight: "600"
        },
        OnboardingScreenTitleTextColor: {
          color: "#222828"
        },
        OrderInfoBannerCartIconText: {
          _web: {
            pt: 1
          }
        },
        LoginHeaderText: {
          _web: {
            pt: 1
          }
        },
        checkoutTopLabelText: {
          _web: {
            pt: 1
          }
        },
        CheckOutHeaderText: {
          ml: 1
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        RecommendedPairingText: {
          color: "#303030"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 14,
            lg: 16
          },
          fontWeight: 500,
          fontFamily: "TradeGothicLTStd-Bold",
          pt: 1
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 400,
          lineHeight: 6,
          color: "#BE2F37"
        },
        checkSummaryTitle: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 16,
          fontWeight: 700,
          lineHeight: 6,
          color: "#303030",
          fontFamily: "headingSecondary"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 700,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#BE2F37"
        },
        viewCheckText: {
          color: "#782434",
          fontWeight: 400,
          fontSize: 15,
          lineHeight: 5,
          textTransform: "uppercase"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        emailReceiptText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 15,
          fontFamily: "TradeGothicLTStd-Medium",
          color: "themeGrey",
          lineHeight: 3
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#BE2F37",
            lg: "#BE2F37"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mt: 6
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          checkinSuccessNoteTitleText: {
            color: "#FFFFFF",
            pt: 3,
            fontSize: 22,
            lineHeight: 42,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          checkinSuccessNoteBodyText: {
            color: "#FFFFFF",
            pt: 1,
            maxWidth: 173,
            textAlign: "center",
            fontWeight: 300,
            fontSize: 14,
            lineHeight: 16,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 600,
          marginY: 11,
          marginX: 5
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        menuItemInfoPrice: {
          fontWeight: 300
        },
        categoryText: function categoryText(_ref21) {
          var isActive = _ref21.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: "600"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "28px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300",
          pt: 0
        },
        nutritinalInfo: {
          _web: {
            fontSize: "18px"
          },
          fontWeight: 400
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 200,
            color: "#fff",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref22) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref22.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 500,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            _web: {
              fontSize: {
                base: "24px",
                md: "45px"
              }
            },
            _ios: {
              fontSize: [26, 26, 36]
            },
            _android: {
              fontSize: [26, 26, 36]
            },
            fontWeight: "600" // fontFamily: "TradeGothicLTStd-Medium",

          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "20px",
                md: "36px"
              }
            },
            _ios: {
              fontSize: [18, 18, 28]
            },
            _android: {
              fontSize: [18, 18, 28]
            },
            fontWeight: "600"
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "16px",
                md: "28px"
              }
            },
            _ios: {
              fontSize: [16, 16, 24]
            },
            _android: {
              fontSize: [16, 16, 24]
            },
            color: "#70695C",
            fontWeight: 600
          };
        },
        locationText: {
          color: "#FFF",
          fontSize: "sm",
          fontFamily: "body",
          pt: 2
        },
        phoneNumberText: {
          color: "#FFF",
          fontSize: "sm",
          fontFamily: "body",
          pt: 1
        },
        btnText: {
          color: "#FFF",
          fontFamily: "heading",
          pt: 1
        },
        headerText: {
          color: "#FFF",
          fontSize: 24,
          fontWeight: "600"
        },
        cartItemCancelText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 500
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 600,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: 22,
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref23) {
          var isMandatory = _ref23.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: "white",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref24) {
          var isMandatory = _ref24.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref25) {
          var isMobile = _ref25.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref26) {
          var isDefaultExpanded = _ref26.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: "white"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "white",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 14,
            fontWeight: 700,
            color: "orderConfirmationTextColor"
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "#303030",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 16,
            py: 4
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            mb: 2,
            _web: {
              fontSize: ["xl", "xl", "32px"]
            },
            fontSize: ["xl", "xl", 10],
            fontWeight: "700"
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: 400
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "600",
            fontSize: "sm",
            pt: 0
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "lg",
          fontWeight: 300,
          lineHeight: 6
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600,
          color: "#303030"
        },
        allLocationsSelectText: {
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 600,
          color: "#303030"
        },
        allLocationsText: function allLocationsText(_ref27) {
          var isLocationSearchPage = _ref27.isLocationSearchPage;
          return {
            fontSize: 22,
            color: isLocationSearchPage ? "#2A2C25" : "primary.100",
            fontWeight: 600
          };
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref28) {
          var addButtonText = _ref28.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : 18,
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            _ios: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            }
          };
        },
        menuItemPrice: {
          fontSize: {
            base: 12,
            lg: 16
          },
          fontWeight: 500,
          pr: 1
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 16],
          fontWeight: 300,
          pl: 1
        },
        confirmPickupDetailsHeaderText: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 400,
          textAlign: "center"
        },
        confirmPickupDetailsRestaurant: {
          fontSize: 14,
          color: "#303030",
          fontWeight: "500"
        },
        menuListTextCTA: {
          fontWeight: 300,
          fontSize: [10, 10, 14, 16, 16]
        },
        cartHeaderLocationName: {
          color: "primary.100",
          fontWeight: 600
        },
        cartItemMenuName: {
          color: "menuItemNameColor",
          fontWeight: 500,
          fontSize: 17
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs",
            pt: 2,
            _web: {
              pt: "6px"
            }
          };
        },
        cartHeaderOrderType: {
          color: "#303030"
        },
        cartItemRemoveText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 500
        },
        reorderAddButtonText: {
          fontSize: 18,
          fontWeight: 600,
          color: "reOrderAddBtnBorder"
        },
        pdfMenuButtonText: {
          my: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref29) {
          var isFromLocationSearch = _ref29.isFromLocationSearch;
          return {
            fontWeight: "600",
            fontSize: isFromLocationSearch ? {
              base: "16px",
              md: "18px"
            } : "16px",
            lineHeight: 18,
            textAlign: "left"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref30) {
          var isFromLocationSearch = _ref30.isFromLocationSearch;
          return {
            fontSize: {
              base: "xs",
              md: "14px"
            },
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 14,
            lg: 16
          },
          lineHeight: 3,
          fontWeight: 500,
          fontFamily: "TradeGothicLTStd-Bold",
          pt: 1
        },
        confirmationPickupRestNameTitle: {
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1,
          fontSize: 14,
          pt: 0
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: 14,
          pt: 0
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "#303030",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "600",
            fontFamily: "heading"
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark",
            pt: 0
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "#303030",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "600",
            fontFamily: "heading"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "#303030",
            fontSize: {
              base: 16,
              lg: 18
            },
            fontWeight: 600,
            fontFamily: "TradeGothicLTStd-Bold"
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "600",
            letterSpacing: -0.3
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#BE2F37",
            _ios: {
              color: "#BE2F37",
              fontSize: 18,
              textTransform: "capitalize"
            },
            _android: {
              color: "#BE2F37",
              fontSize: 18,
              textTransform: "capitalize"
            },
            fontSize: {
              base: 24,
              lg: 36
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            },
            fontWeight: "600",
            fontFamily: "heading",
            _web: {
              fontFamily: "heading"
            }
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#303030",
            fontSize: 16,
            fontWeight: "300",
            fontFamily: "TradeGothicLTStd-Light",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#282C25",
            fontSize: 16,
            fontWeight: "500",
            fontFamily: "TradeGothicLTStd-Bold",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#494949",
            fontSize: {
              base: 18
            },
            fontFamily: "TradeGothicLTStd-Light",
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#494949"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "confirmationPrimary",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderDetailsTitle: function confirmationOrderDetailsTitle() {
          return {
            color: "confirmationPrimary",
            fontFamily: "TradeGothicLTStd-Bold"
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 16,
              lg: 16
            },
            letterSpacing: "-0.5px",
            fontFamily: "TradeGothicLTStd-Bold"
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel(_ref31) {
          var fromOrderHistory = _ref31.fromOrderHistory;
          return fromOrderHistory ? {
            fontSize: 23,
            color: "#303030",
            fontWeight: 500,
            letterSpacing: "-0.3"
          } : {};
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            fontSize: {
              base: 23,
              lg: 27
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-1px"
            }
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle(_ref32) {
          var fromOrderHistory = _ref32.fromOrderHistory;
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            fontSize: 18,
            letterSpacing: "-0.5px",
            color: fromOrderHistory ? "#303030" : "confirmationPrimary"
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: 14,
            letterSpacing: "-0.5px",
            pt: 0,
            color: "#606060",
            fontWeight: "400"
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontFamily: "TradeGothicLTStd-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontFamily: "TradeGothicLTStd-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        cartItemMenuPropertyName: {
          color: "#303030"
        },
        confirmationSvgCenteredText: function confirmationSvgCenteredText() {
          return {
            pb: {
              base: "1px",
              lg: "2px"
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            _ios: {
              py: 0
            },
            _android: {
              py: 0
            },
            fontSize: {
              base: 12,
              lg: 14
            },
            lineHeight: 3 // fontFamily: "TradeGothicLTStd-Bold",

          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            lineHeight: 3,
            fontWeight: 500,
            fontFamily: "TradeGothicLTStd-Bold",
            letterSpacing: -0.4,
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "primary.100",
            fontWeight: 400,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#4D2C42",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationName: {
          fontSize: 14,
          fontWeight: 400,
          color: "#303030"
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#B31900",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          pl: 8
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 10,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          style: {
            color: "#fff0",
            textShadowColor: "rgba(0,0,0,1)",
            textShadowOffset: {
              width: 0,
              height: 0
            },
            textShadowRadius: 10
          }
        },
        refreshWaitlist: {
          fontWeight: 300
        },
        waitlistDisclaimer: {
          fontWeight: 300
        },
        waitlistOrder: {
          color: "#BE2F37",
          textTransform: "uppercase",
          fontWeight: 500,
          fontSize: 12
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        myLocationsLoginText: {
          fontWeight: 700,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        // new
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#721C24",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 3
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 16
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 400,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        mobileOrderDetailsHeader: function mobileOrderDetailsHeader() {
          return {
            fontWeight: 400,
            fontSize: 18
          };
        },
        mobileOrderDetailsStatic: function mobileOrderDetailsStatic() {
          return {
            fontWeight: 300,
            fontSize: 12
          };
        },
        mobileOrderDetailsInput: function mobileOrderDetailsInput() {
          return {
            fontWeight: 400,
            fontSize: 16
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            fontWeight: "700",
            fontFamily: "TradeGothicLTStd-Bold",
            alignItems: "center",
            color: "restaurantInfoAddToFavouritiesTextColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: 1
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            fontFamily: "TradeGothicLTStd-Bold",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            textTransform: "uppercase",
            fontSize: {
              base: "24px",
              lg: "42px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 500,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "primary.100",
            color: "primary.100"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref33) {
          var customMarginHorizontal = _ref33.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "#606060"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: {
              base: "#404040",
              lg: "#303030"
            }
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#404040"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref34) {
          var disabled = _ref34.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontFamily: "TradeGothicLTStd-Bold",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            fontSize: {
              base: 24,
              lg: 24
            },
            color: "restaurantHoursTextColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            },
            pt: 1
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "48%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "52%"
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#404040",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: 24,
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            },
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "200",
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: "16px",
            fontFamily: "TradeGothicLTStd-Bold",
            color: "#BE2F37",
            textAlign: "center",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            fontFamily: "TradeGothicLTStd-Bold",
            paddingBottom: 4,
            fontSize: {
              base: "24px",
              lg: "24px"
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "14",
            lg: "16"
          },
          color: {
            base: "#303030",
            lg: "#494949"
          }
        },
        restaurantDetails_Amenities_Description: {
          fontWeight: "300",
          color: "#606060",
          pt: 1
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: "#303030",
          fontWeight: "600",
          textTransform: "uppercase"
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "#fff",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "16px",
            fontFamily: "TradeGothicLTStd-Bold",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            }
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "restaurantTimingWeekDayTextColor",
            fontSize: {
              base: "12",
              lg: "12"
            },
            position: "absolute",
            bottom: 1
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 500,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        reservationConfirmationText: {
          fontWeight: 200,
          color: "#606060",
          pt: 0
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "#BE2F37"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "#BE2F37"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: "700",
            pt: 1
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "TradeGothicLTStd-Medium",
            color: "#303030",
            fontSize: 14
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 12,
            color: "#606060",
            lineHeight: 5
          };
        },

        /** Text: Private Dining Start */
        privateDiningLocationModalHeaderText: {
          color: "#fff",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        privateDiningFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        pd_requestFlow_form_title: function pd_requestFlow_form_title() {
          return {
            pt: {
              base: 5,
              md: 6
            },
            pb: {
              base: 4,
              md: 6
            },
            fontSize: {
              base: 18,
              md: 22
            },
            lineHeight: 6,
            textAlign: "center",
            color: {
              base: "#FFFFFF",
              md: "#70695C"
            }
          };
        },
        pd_requestFlow_form_tabIndex: function pd_requestFlow_form_tabIndex(_ref35) {
          var isActive = _ref35.isActive;
          return {
            m: "auto",
            color: {
              base: isActive ? "#BE2F37" : "#FFFFFF",
              md: "#FFFFFF"
            },
            fontSize: {
              base: "xs",
              md: "md"
            },
            pt: 1
          };
        },
        pd_requestFlow_form_tabTitle: function pd_requestFlow_form_tabTitle(_ref36) {
          var isActive = _ref36.isActive,
              isCompleted = _ref36.isCompleted;
          return {
            fontWeight: isActive ? 400 : 200,
            fontSize: {
              base: "sm",
              md: "md"
            },
            color: {
              base: isActive || isCompleted ? "#fff" : "#F6F6F6",
              md: isActive || isCompleted ? "#282C25" : "#808080"
            }
          };
        },
        pd_request_eventDetails_locationTitle: {
          fontSize: {
            base: "sm",
            md: "md"
          },
          fontWeight: 500,
          mb: 1.5,
          color: "#282C25"
        },
        pd_request_eventDetails_locationAddress: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          pt: 0
        },
        pd_request_eventDetails_locationPhoneNum: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          color: "#606060",
          pt: 0
        },
        pd_request_eventDetails_locationChange: {
          fontSize: 12,
          fontWeight: "600",
          color: "#BE2F37"
        },
        pd_request_eventDetails_InputTitle: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          mb: 2,
          color: "#303030"
        },
        pd_request_eventDetails_noOfGuest_subMessage: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          mt: 2
        },
        pd_request_eventDetails_splRequestTitle: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 4,
          mr: 3,
          color: "#606060"
        },
        pd_request_contactDetails_InputTitle: {
          color: "#303030",
          fontSize: 14,
          mb: 2,
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_request_contactDetails_dobTitle: {
          color: "#303030",
          fontSize: {
            base: 14,
            md: 16
          },
          mr: 2,
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_request_contactDetails_dobTooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_contactDetails_userInfoName: {
          color: "#303030",
          fontFamily: "TradeGothicLTStd-Bold",
          fontWeight: 500,
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 2
        },
        pd_contactDetails_userInfoExtras: {
          color: "#303030",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: {
            base: 12,
            md: 14
          },
          _ios: {
            lineHeight: 14
          },
          _android: {
            lineHeight: 14
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetails_title: {
          color: "#303030",
          fontWeight: {
            base: "600",
            md: "500"
          },
          fontSize: 12
        },
        pd_reveiwDetails_restName: {
          color: "#303030",
          fontFamily: "TradeGothicLTStd-Bold",
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 1
        },
        pd_reviewDetails_restAddress: {
          color: "#606060",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_restPhoneNum: {
          color: "#303030",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_eventInfoTitle: {
          color: "#606060",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: 12,
          _web: {
            lineHeight: 12
          },
          mb: 2
        },
        pd_reviewDetails_eventInfoData: {
          color: "#2C303B",
          fontSize: {
            base: 14,
            md: 16
          },
          _web: {
            lineHeight: 12
          },
          pt: 1,
          fontWeight: "600"
        },
        pd_reviewDetailsSplReqTitle: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 15,
          fontFamily: "TradeGothicLTStd-Medium",
          mb: 2
        },
        pd_reviewDetailsSplReqData: {
          color: "#606060",
          fontSize: 14,
          fontFamily: "TradeGothicLTStd-Medium",
          fontWeight: 400
        },
        pd_confirmation_title: {
          color: "#BE2F37",
          fontSize: 16,
          maxW: {
            md: "354px"
          },
          textAlign: "center",
          fontWeight: 600
        },
        pd_confirmation_emailText: {
          color: "#505050",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: 14
        },
        pd_confirmation_email: {
          color: "#303030",
          textAlign: "center",
          fontSize: 14,
          fontWeight: "600"
        },
        pd_confirmation_salesMessage: {
          color: "#606060",
          fontFamily: "TradeGothicLTStd-Medium",
          fontSize: 14,
          maxW: {
            md: "387px"
          },
          textAlign: "center"
        },
        pd_confirmation_restPhoneNum: {
          color: "#BE2F37",
          fontSize: 14,
          fontFamily: "TradeGothicLTStd-Medium",
          fontWeight: 400
        },
        pd_cancelModalMessage: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C",
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_cancelModalCancelCTAText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#BE2F37",
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_cancelModalCancelConfirmText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#FFFFFF",
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_CallTheRestPopupTextOne: {
          textAlign: "center",
          fontSize: 16,
          fontWeight: 200,
          lineHeight: 5,
          color: "#70695C",
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_CallTheRestPopupTextTwo: {
          textAlign: "center",
          fontSize: 16,
          fontWeight: 200,
          lineHeight: 5,
          mt: 5,
          px: 3.5,
          color: "#70695C",
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_CallTheRestPopupPhoneNum: {
          fontSize: 16,
          fontWeight: 400,
          color: "#BE2F37"
        },
        pd_CallTheRestPopupPhoneNumCTA: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 6,
          color: "#BE2F37",
          textTransform: "uppercase"
        },

        /** Text: Private Dining End */
        reservationSeatingOptionText: {
          fontWeight: 200,
          color: "#606060"
        },
        pd_request_eventDetails_dineInDate_subMessage: {
          fontSize: "xs",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          mr: 2,
          pt: 1
        },
        pd_request_eventDetails_dineInDate_tooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontWeight: "300"
        },
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: "500",
          pt: 1
        },
        topPaddingText: {
          pt: 0
        },
        reorderNonLoggedInText: {
          fontWeight: "600",
          fontSize: {
            base: 18,
            md: 22
          }
        },
        reservationCheckboxText: {
          fontWeight: 300,
          fontSize: {
            base: 14,
            md: 16
          },
          color: "#606060"
        },
        reservationStaticLinkText: {
          fontWeight: 500,
          color: {
            base: "primary.100",
            md: "#606060"
          }
        },
        reservationListCardDirections: {
          fontWeight: 700,
          lineHeight: 12,
          color: "primary.100",
          fontSize: 12
        },
        reservationListCardLocationText: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 5
        },
        reservationListCardRestName: {
          fontWeight: "600",
          fontSize: 16,
          lineHeight: 5
        },
        reservationListCardRestAddress: {
          fontSize: 12,
          fontWeight: 400,
          lineHeight: 5,
          pt: 0
        },
        reservationListCardCtaText: function reservationListCardCtaText() {
          return {
            pl: 2,
            fontSize: 18,
            pt: 1,
            lineHeight: 5
          };
        },
        pd_review_details_diresctions_text: {
          fontWeight: 400,
          pt: 0.5,
          fontSize: {
            base: 12,
            md: 14
          }
        },
        sectionHeaderLongDescription: {
          fontSize: 14,
          color: "#606060"
        },
        restaurantDetails_explore_rest_Text: {
          color: "primary.100",
          fontSize: 16,
          fontWeight: "500",
          mr: 2,
          pt: 1
        },
        quantityNumber: {
          pt: 1
        },
        eclubSecondarySubsCheckbox: {
          mb: 1
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 200,
          color: "primary.100",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#4E311D",
          fontSize: 24,
          width: "70%",
          lineHeight: 8
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#4E311D",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 400,
          color: "#4E311D",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 400,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "secondary.300",
          textAlign: "center",
          fontSize: 16
        },
        eclub_confirmation_confirmation_heading: {
          fontWeight: 700
        },
        eclub_dob_subText: {
          color: "#808080"
        },
        eclub_selected_restaurant_name: {
          fontWeight: 700
        },
        eclub_changeLocationCTAText: {
          fontWeight: 700
        },
        joinEClubHeading: {
          fontWeight: 500,
          textAlign: "center",
          color: "white",
          fontSize: 28,
          width: "60%",
          lineHeight: 8
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "white",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 20,
          letterSpacing: "-0.3",
          fontWeight: 500
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 24,
          fontWeight: 500,
          my: 2,
          textAlign: "center",
          letterSpacing: "-0.1",
          color: "#303030"
        },
        myAccountConfirmationHeadSubText: {
          color: "#606060",
          fontSize: 16,
          fontWeight: 300,
          my: 0,
          textAlign: "center",
          maxWidth: 337,
          pt: 0
        },
        topUnitPaddingText: {
          pt: 1
        },
        reservationConfirmModalBodyText: {
          fontSize: 14,
          lineHeight: 5,
          color: "#606060",
          textAlign: "center"
        },
        textAlignCenter: {
          textAlign: "center"
        },
        pd_landing_stickyContainer_label: {
          fontSize: {
            base: "xs",
            md: "md"
          },
          fontWeight: 300,
          color: "#303030",
          lineHeight: 5,
          textAlign: {
            base: "center",
            md: "start"
          },
          mt: {
            base: 1,
            lg: 0
          },
          maxWidth: {
            base: 80,
            md: "360px"
          },
          wordBreak: "break-word"
        },
        pd_landing_makeAReq_ctaText: {
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: {
            base: "sm",
            md: "xl"
          },
          lineHeight: 6
        },
        pd_landing_menuTabs_itemLabel: function pd_landing_menuTabs_itemLabel(_ref37) {
          var isActive = _ref37.isActive;
          return {
            textTransform: "uppercase",
            color: isActive ? "#FFFFFF" : "#303030",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 6
          };
        },
        pd_landing_dropdown_activeLable: function pd_landing_dropdown_activeLable(_ref38) {
          var isActive = _ref38.isActive;
          return {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 6,
            color: isActive ? "#303030" : "#FFFFFF",
            textTransform: "uppercase"
          };
        },
        pd_landing_home_subText: {
          color: "themeGrey",
          fontWeight: 300
        },
        pd_landing_home_activeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: 22,
            md: 45
          },
          fontWeight: "600"
        },
        pd_landing_locationHeaderName: {
          pb: 1,
          fontSize: 16,
          fontWeight: 300,
          color: "#303030",
          textTransform: "capitalize"
        },
        pd_landing_locationHeaderChangeLoc: {
          fontSize: 16,
          color: "#BE2F37",
          fontWeight: "600",
          textTransform: "capitalize"
        },
        pd_landing_eventGuideCTA_text: {
          fontWeight: 400,
          color: "#BE2F37",
          fontSize: 16
        },
        pd_landing_floorPlanLink_text: {
          textAlign: "center",
          mt: 3,
          fontSize: 14,
          fontWeight: 300,
          color: "#BE2F37"
        },
        pd_landing_floorPlan_viewGalleryLink: {
          color: "#BE2F37",
          fontSize: {
            base: 14,
            lg: 20
          },
          fontWeight: "600"
        },
        restaurantDetails_PoliteNotice_Title: function restaurantDetails_PoliteNotice_Title() {
          return {
            fontSize: 16,
            fontWeight: 400,
            mb: 5,
            color: "#2A2C25"
          };
        },
        restaurantDetails_PoliteNotice_Desc: function restaurantDetails_PoliteNotice_Desc() {
          return {
            fontSize: 16,
            color: "#606060",
            lineHeight: 5
          };
        },
        topUnitHalfPaddingText: {
          paddingTop: {
            base: 1.5,
            md: 0.5
          }
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030",
          letterSpacing: "-0.3"
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200,
          letterSpacing: "-0.3",
          color: "#606060"
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200,
          letterSpacing: "-0.3",
          color: "#606060"
        },
        myAccountChangeLocationChangeText: {
          color: "#BE2F37",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 500,
          letterSpacing: "-0.3",
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          }
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#2A2C25"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          fontSize: 14,
          lineHeight: 3,
          noOfLines: 1,
          letterSpacing: "-0.4",
          color: "#303030",
          fontWeight: 500
        },
        myAccount_MenuListItem_cardText_subText: {
          fontSize: 12,
          lineHeight: 3,
          color: "#808080",
          noOfLines: 1,
          letterSpacing: "-0.3"
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 3,
          fontWeight: 300,
          color: "#808080",
          letterSpacing: "-0.3"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6,
          fontWeight: 400,
          letterSpacing: "-0.3",
          color: "#303030"
        },
        myAccount_button_editConfirmation_text: {
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "-0.3"
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "500",
          color: "white",
          letterSpacing: "-0.3",
          textTransform: "uppercase"
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#303030"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#303030",
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor"
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 10,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 14,
          color: "#BE2F37",
          textTransform: "uppercase",
          fontWeight: "500",
          letterSpacing: "-0.3"
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#8E774D"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: "-0.3",
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: "-0.3",
          fontWeight: 500,
          lineHeight: 4,
          color: "#BE2F37"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "12px",
              md: "13px"
            },
            fontWeight: 200,
            color: {
              base: "#606060",
              md: "#606060"
            }
          },
          fontSize: 14,
          letterSpacing: "-0.3",
          fontWeight: 400,
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#303030",
          letterSpacing: "-0.4",
          fontWeight: "500"
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#303030",
          fontWeight: 500,
          mb: 6,
          letterSpacing: "-0.3"
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#808080",
          fontWeight: 200,
          mb: 2,
          letterSpacing: "-0.3"
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          color: "#303030",
          letterSpacing: "-0.3"
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#606060",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 0
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            },
            letterSpacing: "-0.3"
          }
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#606060",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            },
            letterSpacing: "-0.2"
          }
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 14,
          color: "#BE2F37",
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          maxWidth: 40,
          fontWeight: 200,
          color: "#606060",
          fontSize: 16,
          letterSpacing: "-0.3",
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "#FFFFFF",
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          _web: {
            letterSpacing: "-0.3"
          }
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor",
          textTransform: "uppercase"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 24,
          lineHeight: 6,
          flex: 1,
          color: "#303030",
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#303030",
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#303030",
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          fontSize: 18,
          lineHeight: 6,
          color: "#BE2F37",
          letterSpacing: "-0.3",
          fontWeight: 500,
          marginTop: 3.5,
          marginBottom: 3.5,
          textAlign: "center",
          _web: {
            mt: 4,
            mb: 4
          }
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 400,
          color: "themeGrey",
          py: 2
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          marginY: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 16,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          marginTop: 14,
          marginBottom: 4,
          fontSize: 18,
          lineHeight: 6,
          textAlign: "center",
          color: "#FFFFFF",
          _web: {
            mt: 4,
            mb: 4,
            letterSpacing: "-0.3",
            fontWeight: 500
          }
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          },
          color: "#FFFFFF"
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "reorderInfoTextColor"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 14,
          fontWeight: 300,
          color: "#303030",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          letterSpacing: "-0.3"
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 3,
          letterSpacing: "0.3",
          color: "#808080"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 500,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: "-0.3",
          mt: 1,
          color: "#303030"
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "#606060"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 3,
          letterSpacing: "0.3",
          color: "#808080"
        },
        order_history_details_pickup_time_desc: {
          mt: 1,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "#303030"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          mb: 2,
          color: "#303030",
          letterSpacing: "0.3"
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "#303030"
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400,
          _web: {
            color: "#BE2F37"
          }
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 500,
          _web: {
            color: "#BE2F37",
            letterSpacing: "-0.2"
          }
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          fontWeight: 500,
          letterSpacing: "-0.3"
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {
          color: "#303030",
          fontSize: 20,
          letterSpacing: "-0.3",
          fontWeight: 500
        },
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 20,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase",
          letterSpacing: "-0.3",
          fontWeight: 500
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 500,
          letterSpacing: "-0.3",
          fontSize: 14
        },
        order_history_details_order_number_text: {
          color: "#BE2F37",
          letterSpacing: "-0.3",
          lineHeight: 6,
          fontSize: 14
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor",
          letterSpacing: "-0.3",
          fontWeight: 500
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#000",
            bg: "#000"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref39) {
          var isError = _ref39.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#DDDDDD",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 0
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 0,
          shadow: 10,
          bg: "white"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "white",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "white"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 0
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref40) {
          var isSelected = _ref40.isSelected;
          return {
            bg: "#E5E5E5",
            borderColor: "themeSectionSeparator",
            shadow: 5,
            overflow: "hidden"
          };
        },
        listItemBox: {
          borderRadius: 0
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref41) {
          var radiusValue = _ref41.radiusValue,
              topRadiusValue = _ref41.topRadiusValue,
              bottomRadiusValue = _ref41.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },

        /* HStack: Private Dining Start */
        pd_Header_Container: function pd_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            bg: "#000",
            borderBottomWidth: 1,
            borderBottomColor: "#000"
          };
        },
        privateDiningLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        pd_request_eventDetails_inputContainer: function pd_request_eventDetails_inputContainer(_ref42) {
          var errorMessage = _ref42.errorMessage,
              isActive = _ref42.isActive;
          return {
            py: 3,
            px: 3,
            alignItems: "center",
            borderWidth: 1,
            borderRadius: 0,
            borderColor: errorMessage ? "#D30000" : isActive ? "#BE2F37" : "#DDDDDD",
            bgColor: "white"
          };
        },
        pd_request_eventDetails_selectTime_container: {
          marginTop: 2,
          marginBottom: 1,
          marginX: 5,
          borderColor: "#DEDEDE",
          borderWidth: 1,
          paddingY: 4,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 0
        },
        pd_request_contactDetails_userInfo: {
          borderWidth: 1,
          borderRadius: 0,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },

        /* HStack: Private Dining End */
        pd_landing_menuTabs_container: {
          alignItems: "center",
          justifyContent: "flex-end",
          // bg: "#000",
          flex: 1
        },
        pd_landing_menuDropdown_summary: function pd_landing_menuDropdown_summary(_ref43) {
          var isExpanded = _ref43.isExpanded;
          return {
            p: 5,
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottomColor: isExpanded ? "#E0DED8" : "transparent",
            borderBottomWidth: 1
          };
        },
        pd_landing_eventGuideCTA_body: {
          alignItems: "center",
          justifyContent: "center",
          space: {
            base: 3,
            lg: 4
          },
          py: 2.5,
          bg: "#FFFFFF"
        },
        pd_landing_floorPlanLinksSection: {
          py: {
            lg: 5
          },
          alignItems: "center",
          justifyContent: "center"
        },
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 0,
          borderColor: "#DDDDDD",
          borderWidth: 1,
          bg: "#FFFFFF"
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 5
          },
          backgroundColor: {
            base: "#FFFFFF",
            md: "#EDEDEC"
          },
          borderRadius: 0,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "#FFFFFF",
          alignItems: "center",
          mb: 2
        },
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 10,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "#F8E0E2",
          zIndex: 1
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          },
          alignItems: "flex-start"
        }
      }
    },
    Image: {
      variants: {
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 0,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          },
          borderRadius: 10
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          },
          borderRadius: 10
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref44) {
          var radiusValue = _ref44.radiusValue,
              topRadiusValue = _ref44.topRadiusValue,
              bottomRadiusValue = _ref44.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref45) {
          var active = _ref45.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        },
        pd_select_restaurant_brand_logo: {
          height: "53px",
          width: "138px"
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "TradeGothicLTStd-Medium"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 0
        },
        borderRadiusValue: function borderRadiusValue(_ref46) {
          var radiusValue = _ref46.radiusValue,
              topRadiusValue = _ref46.topRadiusValue,
              bottomRadiusValue = _ref46.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },

        /** Input: Private Dining Start */
        pd_request_eventDetails_noOfGuestinput: {
          borderRadius: 0,
          fontFamily: "TradeGothicLTStd-Medium"
        },
        pd_request_eventDetails_SplRequest: {
          borderRadius: 0
        },
        pd_request_contactDetails_input: {
          borderRadius: 0,
          fontFamily: "TradeGothicLTStd-Medium"
        },

        /** Input: Private Dining End */
        myAccountInputForm: {
          fontFamily: "TradeGothicLTStd-Medium"
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "space-between",
          flex: 1,
          direction: "row-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 0
        },

        /** VStack: Private Dining Start */
        pd_requestForm_Tabs_Container: {
          bgColor: {
            base: "#BE2F37",
            md: "#FFFFFF"
          },
          borderBottomWidth: 1,
          borderBottomColor: "#D6D6D6",
          borderTopRadius: {
            base: 0,
            md: 12
          }
        }
        /** VStack: Private Dining End */

      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 17
        },

        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 0
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 0,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 4,
          bg: "white",
          _web: {
            pb: 9
          },
          borderRadius: 0
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 0,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#fff",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "white"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref47) {
          var isActive = _ref47.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "primary.100"
          };
        },

        /*RESERVATION*/
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "TradeGothicLTStd-Medium"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: 9,
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 0,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref48) {
          var hasSub = _ref48.hasSub;
          return {
            mb: {
              base: hasSub && -0.5,
              md: hasSub && -1
            }
          };
        },
        HomeScreenCTAflex: {
          flexDirection: "column-reverse"
        },
        configOptionBox: {
          borderRadius: 0
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 0,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: "TradeGothicLTStd-Medium",
            color: "#606060",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "360px"
              },
              pb: 5
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref49) {
          var isChild = _ref49.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 0,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 0
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 0,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref50) {
          var isFromLocationSearchPage = _ref50.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: "allLocationsItemBoxBorderColor",
            borderRadius: 0,
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: "#ffffff"
          };
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref51) {
          var isMobile = _ref51.isMobile;
          return {
            borderRadius: 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref52) {
          var hideWaitlistSection = _ref52.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref53) {
          var isSticky = _ref53.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0,
            backgroundColor: "#f6f6f6"
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref54) {
          var isMobile = _ref54.isMobile,
              singleActionButton = _ref54.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#BE2F37"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref55) {
          var isInStack = _ref55.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden",
          borderRadius: 10
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          shadow: 11,
          mr: 6,
          borderRadius: 10
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: {
            base: "#fff",
            md: "#f6f6f6"
          }
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Location search
        tabLocationsTopWidth: 0,
        locationSearchActiveTab: function locationSearchActiveTab(_ref56) {
          var isActive = _ref56.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref57) {
          var radiusValue = _ref57.radiusValue,
              topRadiusValue = _ref57.topRadiusValue,
              bottomRadiusValue = _ref57.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref58) {
          var isSmallScreen = _ref58.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          borderRadius: 0,
          shadow: 17
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref59) {
          var isIOS = _ref59.isIOS;
          return {
            _text: {
              color: "white",
              fontSize: 12,
              _android: {
                pb: 0.5
              }
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 88,
          width: 46
        },
        paymentOptions_giftCardLarge_deleteCTA: {
          bg: "#FFFFFF",
          mt: 4
        },

        /** Box: Private Dining Start */
        privateDiningDropdownRadius: 6,
        privateDiningLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        privateDiningLocationDropdownBox: {
          bg: "#fff",
          h: {
            base: "72px",
            md: "82px"
          },
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        pd_makeRequest_container: {
          minW: {
            base: "100%",
            md: "794"
          },
          m: {
            md: "auto"
          },
          my: {
            md: 6
          },
          minH: {
            md: "543"
          },
          bg: {
            base: "#F6F6F6",
            md: "white"
          },
          borderRadius: 0,
          borderColor: "#D6D6D6",
          borderWidth: {
            base: 0,
            md: 1
          }
        },
        pd_requestFlow_form_tabActiveBorder: function pd_requestFlow_form_tabActiveBorder(_ref60) {
          var isActive = _ref60.isActive;
          return {
            mt: {
              base: 3,
              md: 4
            },
            height: 1,
            bgColor: {
              base: isActive ? "#fff" : "transparent",
              md: isActive ? "requestFormTabActiveItem" : "transparent"
            },
            w: "100%",
            borderTopRadius: 0
          };
        },
        pd_request_eventDetails_locationDetails: {
          py: {
            base: 3,
            md: 4
          },
          px: {
            base: 3,
            md: 4
          },
          borderRadius: 0,
          borderWidth: 1,
          borderColor: "#DEDEDE",
          bgColor: "white"
        },
        pd_actionSheetBorderRadius: 0,
        pd_reviewDetails_container: {
          borderWidth: 1,
          borderRadius: 0,
          borderColor: "#DDD",
          p: 4,
          bg: "white"
        },
        pd_confirmationText_Container: {
          rounded: 0,
          border: 1,
          borderColor: "#DCDCDC",
          py: 5,
          px: {
            base: 4,
            md: "56px"
          },
          bg: "white",
          alignItems: "center"
        },
        pd_reviewDetails_messageRegardingRequest: {
          display: "none"
        },
        pd_requestFlow_form_tabBG: function pd_requestFlow_form_tabBG(_ref61) {
          var isActive = _ref61.isActive,
              isCompleted = _ref61.isCompleted;
          return {
            bgColor: {
              base: isCompleted || isActive ? "#fff" : "#78252A",
              md: isActive ? "requestFormTabActiveItem" : "requestFormTabDisableItem"
            }
          };
        },

        /** Box: Private Dining End */
        displayNone: {
          display: "none"
        },
        pd_landing_eventGuideContainer: {
          width: "100%",
          px: {
            base: 5,
            lg: "115px"
          },
          mb: {
            base: 10,
            lg: "80px"
          },
          mt: {
            base: 4,
            lg: "0px"
          }
        },
        pd_landing_menuDropdown: function pd_landing_menuDropdown(_ref62) {
          var isExpanded = _ref62.isExpanded;
          return {
            p: 0,
            bgColor: isExpanded ? "#FFFFFF" : "#BE2F37",
            _hover: {
              bg: isExpanded ? "#FFFFFF" : "#BE2F37"
            },
            _expanded: {
              bg: isExpanded ? "#FFFFFF" : "#BE2F37"
            }
          };
        },
        flex1: {
          flex: 1
        },
        eClubSignUpBox: {
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center",
          borderRadius: {
            base: 0,
            md: 10
          }
        },
        eClubNewsBox: {
          borderRadius: 10,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          borderRadius: 20,
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "#F6F6F6"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        eClubBGGradient_box: {// empty
        },
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 0,
          bg: "#FFFFFF",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#B7BEC5"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#B7BEC5",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          mb: {
            base: 8,
            md: 2
          },
          paddingY: 5,
          bg: {
            base: "#F6F6F6",
            md: "#FFFFFF"
          }
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 0,
          overflow: "hidden"
        },
        myAccount_paymentOptions_container: {
          marginBottom: 5,
          my: 1,
          backgroundColor: "#FFFFFF",
          _web: {
            height: "100%",
            bg: {
              base: "myAccountScreenBackroundColor",
              md: "#FFFFFF"
            },
            my: {
              base: 0,
              md: 1
            }
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#54301A",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 12,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "#DDDDDD",
          borderBottomWidth: 1,
          borderColor: "#DDDDDD",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          borderColor: "weekDayBorderColor",
          borderWidth: 1,
          borderRadius: 0,
          py: 2,
          px: 3,
          _web: {
            borderColor: "#BE2F37"
          }
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          },
          bg: "#EDEDEC"
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 3,
          _web: {
            width: {
              base: "100%",
              md: "60%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          },
          bg: "#F6F6F6"
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          pt: 2,
          pb: 4,
          w: "100%",
          bg: "#EDEDEC"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between",
          bg: {
            base: "#F6F6F6",
            md: "#FFFFFF"
          },
          pt: {
            base: 3,
            md: 6
          }
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#F8E0E2",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#F8E0E2",
          accessible: false,
          _web: {
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#F6F6F6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "#FFFFFF",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            paddingY: 1
          },
          _ios: {
            marginTop: 6
          },
          paddingX: 5,
          alignItems: "center",
          _web: {
            bg: {
              base: "#F6F6F6",
              md: "#FFFFFF"
            },
            py: {
              base: 5,
              md: 3.5
            },
            alignItems: {
              md: "flex-end"
            },
            px: {
              md: 6
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          },
          color: "#292D36"
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 4,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#AFAFAF"
        },
        // My Account ends,
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4,
          _android: {
            bgColor: "editProfileScreensBackgroundColor"
          },
          _ios: {
            bgColor: "editProfileScreensBackgroundColor"
          }
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "#FFFFFF"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 56,
          width: 80,
          _web: {
            height: "60px",
            width: "123px"
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%",
          bg: "#FFFFFF"
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref63) {
          var radiusValue = _ref63.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(90deg, #931219 0%, #0F0001 100%)"
              }
            },
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0,
            pt: 2
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: "#FFFFFF"
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 5,
          paddingBottom: 7,
          justifyContent: "center"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center",
          bg: "#FFFFFF"
        },
        myAccount_editFields_actionSheet_webBox: {
          pb: 7
        },
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 0
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref64) {
          var radiusValue = _ref64.radiusValue,
              topRadiusValue = _ref64.topRadiusValue,
              bottomRadiusValue = _ref64.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 0,
          backgroundColor: "#FFFFFF",
          shadow: 9
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          paddingX: 3,
          marginRight: 3
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref65) {
          var isMobile = _ref65.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: 0,
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#EDEDEC",
          rounded: 0,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref66) {
          var radiusValue = _ref66.radiusValue,
              topRadiusValue = _ref66.topRadiusValue,
              bottomRadiusValue = _ref66.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref67) {
          var radiusValue = _ref67.radiusValue,
              topRadiusValue = _ref67.topRadiusValue,
              bottomRadiusValue = _ref67.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {},
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "#EDEDEC",
          borderRadius: 0
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "#EDEDEC"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0,
          bg: "#FFFFFF"
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref68) {
          var radiusValue = _ref68.radiusValue;
          return {
            borderRadius: radiusValue
          };
        },

        /** PopoverContent: Private Dining Start */
        pd_request_eventDetails_purposDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_timeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          shadow: 10,
          borderColor: "transparent"
        },
        pd_request_eventDetails_partySizeDropdown: {
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_eventDetails_menuPrefDropdown: {
          top: {
            md: 20
          },
          bg: "#ffffff",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "#E4E4E4"
        },
        pd_request_contactDetails_dopTooltip: {
          backgroundColor: "#606060",
          borderRadius: 0
        },
        pd_request_contactDetails_phoneType: {
          borderRadius: 0,
          py: 6,
          px: 4,
          bg: "white",
          top: 2,
          shadow: 13,
          border: "none"
        }
        /** PopoverContent: Private Dining End */

      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref69) {
          var radiusValue = _ref69.radiusValue,
              topRadiusValue = _ref69.topRadiusValue,
              bottomRadiusValue = _ref69.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%",
          borderRadius: 0
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          my: 3.5,
          _web: {
            mt: 5,
            mb: 6
          },
          color: "#BE2F37",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 3.5,
          _web: {
            mt: 5,
            mb: 6
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Checkbox: {
      variants: {
        eclub_restaurantOptions: {
          alignItems: "center"
        }
      }
    }
  },
  fontConfig: {
    TradeGothicLTStd: {
      100: {
        normal: "TradeGothicLTStd-Light"
      },
      200: {
        normal: "TradeGothicLTStd-Light"
      },
      300: {
        normal: "TradeGothicLTStd-Medium"
      },
      400: {
        normal: "TradeGothicLTStd-Medium"
      },
      500: {
        normal: "TradeGothicLTStd-Bold"
      },
      600: {
        normal: "TradeGothicLTStd-Bold"
      },
      700: {
        normal: "TradeGothicLTStd-ExtraBold"
      }
    }
  },
  fonts: {
    heading: "TradeGothicLTStd",
    body: "TradeGothicLTStd",
    headingSecondary: "TradeGothicLTStd-ExtraBold",
    youMightLikeText: "TradeGothicLTStd-Bold" // s52: "TradeGothicLTStd",

  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));